import Screw from "@scene/objects/screw/screw";
import { initState as initDimensionState } from "@reducers/selectors/dimension";
import { APP_TYPES } from "@config";
import { buttonsOptions as safetyBarrierButtons} from "@reducers/selectors/application/initialState-safety-barrier";
import { ScrewGroup } from "@scene/objects/screw";

export default {
  count: {
    n: safetyBarrierButtons[0].subtypes[0].plate[1].config.screw.count.n, // Use triangle, square and circle
    m: safetyBarrierButtons[0].subtypes[0].plate[1].config.screw.count.m, // Use triangle, square
    // For square, e.g. ignore center screw position
    ignorePositions: safetyBarrierButtons[0].subtypes[0].plate[1].config.screw.count.ignorePositions, 
    toHorizontalMiddle: safetyBarrierButtons[0].subtypes[0].plate[1].config.screw.count.toHorizontalMiddle
  },
  forBend: {
    topCount: 0, // safetyBarrierButtons[0].subtypes[0].plate[1].config.screw.forBend.topCount,
    sideCount: 0 // safetyBarrierButtons[0].subtypes[0].plate[1].config.screw.forBend.sideCount
  },
  custom: {
    allow: false, // If user select n type screws
    active: false, // If user select specify coordinated
    positions: [] // Container screws positions
  },
  heightType: Screw.types.height.DEFAULT,
  types: [],
  padding: {
    // For triangle
    s: 100,
    // For square
    s1: initDimensionState[APP_TYPES.SAFETY_BARRIER].basePlate.spacing.s1,
    s2: initDimensionState[APP_TYPES.SAFETY_BARRIER].basePlate.spacing.s2,
    // For circle
    diameter: initDimensionState[APP_TYPES.SAFETY_BARRIER].basePlate.spacing.d
  },
  coordinatesList: [], // Contain screw coordinates
  radius: 6,
  formation: ScrewGroup.formation.FILLED_SQUARE,
};



// WEBPACK FOOTER //
// ./src/reducers/options/screw/defaults/safetyBarrier.js